// Human-readable labels for teams.season_status (022) — a Season Team's
// competitive-season lifecycle, distinct from and independent of
// teams.status (active/archived, the older admin visibility toggle;
// see utils/teamRoles.js for role labels, which is a separate concern).
// Display-only in this pass — no lifecycle mutation UI reads or writes
// through this file.
export const SEASON_STATUS_LABELS = {
  setup: 'Setup',
  preseason: 'Preseason',
  active: 'Active',
  closeout: 'Awaiting Finalization',
  ended: 'Season Ended',
};

export function seasonStatusLabel(status) {
  return SEASON_STATUS_LABELS[status] || status;
}

// Chip color pairing, reusing this app's existing color language: green
// for "active/good", amber for "needs attention", muted blue-gray for
// "neutral/historical" — same palette TeamDetailPage's Archived chip and
// TeamStaffPage's role chips already use.
export const SEASON_STATUS_CHIP_STYLE = {
  setup:     { bgcolor: '#1a2e44', color: '#9eb8d0' },
  preseason: { bgcolor: '#0f2136', color: '#6a8aa8' },
  active:    { bgcolor: '#0a2a14', color: '#2ea84b' },
  closeout:  { bgcolor: '#2a1405', color: '#f5a623' },
  ended:     { bgcolor: '#1a2e44', color: '#9eb8d0' },
};

export function seasonStatusChipStyle(status) {
  return SEASON_STATUS_CHIP_STYLE[status] || { bgcolor: '#1a2e44', color: '#9eb8d0' };
}
